import { render, staticRenderFns } from "./ObservationRespondingForm.vue?vue&type=template&id=8faa169a&scoped=true"
import script from "./ObservationRespondingForm.vue?vue&type=script&lang=js"
export * from "./ObservationRespondingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faa169a",
  null
  
)

export default component.exports